import { useMemo } from 'react'
import { useDocuments } from '@/features/chat/documents/useDocuments'
import { isDocumentsApiAvailable } from '@/services/documents/documentsApi'
import { DOCUMENTS_DEMO_ITEMS } from './documentsDemoData'

export function useDocumentsLibrary() {
  const documentsQuery = useDocuments()
  const apiAvailable = isDocumentsApiAvailable()
  const items = useMemo(() => {
    if (!apiAvailable) return DOCUMENTS_DEMO_ITEMS
    return documentsQuery.data ?? []
  }, [apiAvailable, documentsQuery.data])

  return {
    items,
    apiAvailable,
    isLoading: apiAvailable && documentsQuery.isLoading,
    isError: apiAvailable && documentsQuery.isError,
  }
}
